import { Link, useLocation } from "react-router-dom";
import { useBilingual } from "@/lib/bilingual";

export default function NotFound() {
  const location = useLocation();
  const b = useBilingual();

  return (
    <div className="relative flex flex-col items-center justify-center h-screen text-center px-4">
      <h1 className="absolute bottom-0 text-9xl md:text-[12rem] font-black text-gray-50 select-none pointer-events-none z-0">
        404
      </h1>
      <div className="relative z-10">
        <h1 className="text-xl md:text-2xl font-semibold mt-6">
          {b("Page not found", "找不到此頁面")}
        </h1>
        <p className="mt-2 text-base text-gray-400 font-mono">{location.pathname}</p>
        <p className="mt-4 text-lg md:text-xl text-gray-500">
          {b(
            "The page you're looking for doesn't exist or has been moved.",
            "您尋找的頁面不存在，或已被移動。",
          )}
        </p>
        <Link
          to="/"
          className="inline-block mt-8 bg-amber-700 hover:bg-amber-600 text-white px-6 py-3 rounded-full text-sm font-semibold cursor-pointer transition-colors"
        >
          {b("Back to Home", "返回首頁")}
        </Link>
      </div>
    </div>
  );
}
